import React from 'react';
import styles from './input.module.scss';

type Props = {
  id?: string;
  placeholder?: string;
  value?: string;
  className?: string;
};

const Input = ({ id, placeholder, value, className }: Props) => {
  return (
    <input
      id={id}
      defaultValue={value}
      placeholder={placeholder}
      className={`${styles['input']} ${className}`}
    />
  );
};

export default Input;
